// src/stores/theme.js
import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

export const THEMES = {
  DARK: 'dark',
  LIGHT: 'light'
};

const THEME_STORAGE_KEY = 'theme-preference';

export const useThemeStore = defineStore('theme', () => {
  // Estado inicial: verifica localStorage, caso contrário usa tema claro como padrão
  const getInitialTheme = () => {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored && Object.values(THEMES).includes(stored)) {
      return stored;
    }
    // Padrão: tema claro (só muda se usuário escolher escuro)
    return THEMES.LIGHT;
  };

  const currentTheme = ref(getInitialTheme());
  const isDark = ref(currentTheme.value === THEMES.DARK);

  // Watch para sincronizar isDark
  watch(currentTheme, (newTheme) => {
    isDark.value = newTheme === THEMES.DARK;
  });

  function setTheme(theme) {
    if (!Object.values(THEMES).includes(theme)) {
      console.warn(`Tema inválido: ${theme}`);
      return;
    }
    currentTheme.value = theme;
    localStorage.setItem(THEME_STORAGE_KEY, theme);
    applyTheme(theme);
  }

  function toggleTheme() {
    const newTheme = currentTheme.value === THEMES.DARK ? THEMES.LIGHT : THEMES.DARK;
    setTheme(newTheme);
  }

  function applyTheme(theme) {
    document.documentElement.setAttribute('data-theme', theme);
    // Atualiza meta theme-color para melhor experiência mobile
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', theme === THEMES.DARK ? '#0f172a' : '#f8fafc');
    }
  }

  // Inicializa o tema ao carregar
  function initTheme() {
    applyTheme(currentTheme.value);
  }

  return {
    currentTheme,
    isDark,
    setTheme,
    toggleTheme,
    initTheme,
    THEMES
  };
});
